import React, { Dispatch } from 'react';

// State
type AppState = {
  drawerOpen: boolean;
  // Set by the current page's RouteContainer, shown in the shell's App Bar
  routeTitle: string;
  routeLoading: boolean;
};
const initialState: AppState = {
  drawerOpen: false,
  routeTitle: '',
  routeLoading: false,
};

// Actions
type AppActions =
  | { type: 'TOGGLE_DRAWER' }
  | { type: 'DRAWER_CLOSE' }
  | { type: 'SET_ROUTE'; payload: { title: string; loading: boolean } };

const reducer = (state: AppState, action: AppActions) => {
  switch (action.type) {
    case 'TOGGLE_DRAWER': {
      return { ...state, drawerOpen: !state.drawerOpen };
    }
    case 'DRAWER_CLOSE': {
      return { ...state, drawerOpen: false };
    }
    case 'SET_ROUTE': {
      return {
        ...state,
        routeTitle: action.payload.title,
        routeLoading: action.payload.loading,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export const AppContext = React.createContext(
  {} as {
    state: AppState;
    dispatch: Dispatch<AppActions>;
  },
);

export function AppProvider(props: { children: React.ReactNode }) {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {props.children}
    </AppContext.Provider>
  );
}
